module.exports = __webpack_public_path__ + "static/media/19ESCAP18.14a768a7.jpg";